import React from "react";

import { Link } from "react-router-dom";

const EcavowhiteComponent = (props) => {
  return (
    <>
      <img src={props.currrentImg} alt="img2" />
      <div className="whiteComponentEcavoText">
        <div className="whiteHeading">{props.heading}</div>
        <p className="whiteP">{props.text}</p>
        {/* <button className="whiteButton">Know More</button> */}
        <Link to={props.Link} className="whiteButton">
          Know More
        </Link>
      </div>
    </>
  );
};

export default EcavowhiteComponent;

// import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
// import useAOS from '../hooks/useAOS';
// import AOS from 'aos';

// const EcavowhiteComponent = (props) => {
//   useAOS();

//   useEffect(() => {
//     AOS.refresh();
//   }, []);

//   return (
//     <div className="whiteComponentEcavo bg8">
//       <img src={props.currrentImg} alt="img2" data-aos="fade-in" />
//       <div className="whiteComponentEcavoText">
//         <div data-aos="fade-up" data-aos-delay="300" className="whiteHeading">{props.heading}</div>
//         <p data-aos="fade-up" data-aos-delay="400" className="whiteP">{props.text}</p>
//         <Link
//           to={props.Link}
//           data-aos="fade-up"
//           data-aos-delay="500"
//           className="whiteButton"
//         >
//           Know More
//         </Link>
//       </div>
//     </div>
//   );
// };

// export default EcavowhiteComponent;

// EcavowhiteComponent.js
// import React from "react";
// import { Link } from "react-router-dom";
// import useIntersectionObserver from '../hooks/useIntersectionObserver';

// const EcavowhiteComponent = (props) => {
//   const [ref, inView] = useIntersectionObserver({ threshold: 0.1 });

//   return (
//     <div ref={ref} className={`whiteComponentEcavo bg8 ${inView ? 'animate' : ''}`}>
//       <img src={props.currrentImg} alt="img2" className="fade-in" />
//       <div className="whiteComponentEcavoText">
//         <div className="whiteHeading">{props.heading}</div>
//         <p className="whiteP">{props.text}</p>
//         <Link to={props.Link} className="whiteButton">
//           Know More
//         </Link>
//       </div>
//     </div>
//   );
// };

// export default EcavowhiteComponent;
